export default __webpack_public_path__ + "2696cd89cdd5d91e3e51aa5b68bab2c1.png";